import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { PartnerAPI } from "@/lib/partnerApi";

/**
 * Public affiliate-link redirect page.
 * Hitting /go/:slug logs the click via /api/partner/affiliate/track/:slug
 * and then window.location.replaces to the destination (creators.eigooinc.net?ref=slug).
 */
export default function AffiliateGo() {
    const { slug } = useParams();
    const once = useRef(false);

    useEffect(() => {
        if (once.current) return;
        once.current = true;
        (async () => {
            try {
                const data = await PartnerAPI.affiliateTrack(slug);
                const dest =
                    data?.destination ||
                    `https://creators.eigooinc.net?ref=${slug}`;
                window.location.replace(dest);
            } catch {
                window.location.replace(
                    `https://creators.eigooinc.net?ref=${slug}`,
                );
            }
        })();
    }, [slug]);

    return (
        <div
            className="min-h-[70vh] bg-forest text-cream flex items-center justify-center"
            data-testid="affiliate-go-page"
        >
            <div className="text-center">
                <Loader2 size={32} className="animate-spin text-gold mx-auto" />
                <p className="mt-4 text-cream/70 text-sm tracking-[0.28em] uppercase">
                    Redirecting to EIGOO Creator Hub…
                </p>
                <p className="mt-2 text-cream/50 text-xs font-mono">
                    ref: {slug}
                </p>
            </div>
        </div>
    );
}
